var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3966_5508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C8.81812 0 5.76375 1.26506 3.51562 3.51469C1.26518 5.76521 0.000623381 8.81734 0 12C0 15.1813 1.26562 18.2357 3.51562 20.4853C5.76375 22.7349 8.81812 24 12 24C15.1819 24 18.2362 22.7349 20.4844 20.4853C22.7344 18.2357 24 15.1813 24 12C24 8.81869 22.7344 5.76431 20.4844 3.51469C18.2362 1.26506 15.1819 0 12 0Z",
    fill: "url(#paint0_linear_3966_5508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43282 11.8733C8.93157 10.3493 11.2641 9.34448 12.4303 8.85904C15.7641 7.47285 16.4559 7.2321 16.9078 7.22395C17.0072 7.22235 17.2284 7.24692 17.3728 7.36364C17.4928 7.46207 17.5266 7.5952 17.5434 7.68867C17.5584 7.78204 17.5791 7.99485 17.5622 8.16098C17.3822 10.0585 16.6003 14.6631 16.2028 16.7884C16.0359 17.6877 15.7041 17.9892 15.3834 18.0186C14.6859 18.0827 14.1572 17.5581 13.4822 17.1158C12.4266 16.4234 11.8303 15.9925 10.8047 15.3169C9.61969 14.5362 10.3884 14.107 11.0634 13.4057C11.2397 13.2222 14.3109 10.4294 14.3691 10.176C14.3766 10.1444 14.3841 10.0262 14.3128 9.96398C14.2434 9.90154 14.1403 9.92292 14.0653 9.93979C13.9584 9.96379 12.2728 11.079 9.00282 13.2854C8.52469 13.6142 8.09157 13.7745 7.70157 13.7661C7.27407 13.7569 6.44907 13.5239 5.83595 13.3247C5.08595 13.0804 4.48782 12.9512 4.54032 12.5363C4.56657 12.3203 4.8647 12.0992 5.43282 11.8733Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3966_5508",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3966_5508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.50b05553aca5064586aab144fac9404e.svg";
export { ForwardRef as ReactComponent };